import {
  Box,
  Container,
  Heading,
  Stack,
} from '@chakra-ui/react';

export default function GridListWithHeading() {
  return (
    <Box p={4} bg='yellow.100' py='20'>
      <Stack spacing={4} as={Container} maxW={'3xl'} textAlign={'center'}>
        <Heading fontSize={'5xl'} color='black'>Partners</Heading>
      </Stack>
      <Container maxW={'6xl'} mt={10} textAlign={'center'}>
      Will put a image of all partners' logos here <br />
      {/* Wombat <br /> */}
      {/* Cook Finance <br /> */}
      {/* Magpie? <br /> */}
      {/* C-cubed? <br /> */}
      </Container>
    </Box>
  );
}
